var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pui-datatable',{attrs:{"modelName":_vm.modelName,"actions":_vm.actions,"modelColumnDefs":_vm.modelColumnDefs,"externalFilter":_vm.filter()}}),_c('doc-new-version-modal',{attrs:{"modelName":_vm.modelName,"pkAttribute":_vm.pkAttribute}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }